import { onScopeDispose } from '@vue/composition-api'

import { isToastMuted } from '@/libs/toastification'

export function useOrderChangeNotifications(toast, component, openOrder) {
    const groups = new Map()

    const show = payload => {
        // Заглушённый тост не вызовет onClose, и группа осталась бы в groups навсегда
        if (!payload?.orderId || isToastMuted()) return

        const text =
            payload.notificationText ??
            `Произошли изменения с заказом ${payload.orderNumber || ''}`
        const [heading, ...lines] = text.split('\n')
        const labels = lines.map(line => line.trim())
        // Only field lists share a toast; status warnings remain independent.
        const canGroup =
            (!payload.notificationType ||
                payload.notificationType === 'info') &&
            labels.length > 0 &&
            labels.every(label => /^•\s+\S/.test(label))
        const key = canGroup ? JSON.stringify([payload.orderId, heading]) : null
        const group = key === null ? null : groups.get(key)
        const fields = new Set([...(group?.fields || []), ...labels])
        const content = {
            component,
            props: {
                orderId: payload.orderId,
                type: payload.notificationType,
                changes: canGroup
                    ? `${heading}\n ${[...fields].join('\n ')}`
                    : text,
            },
            listeners: { 'open-order': openOrder },
        }

        if (group) {
            group.fields = fields
            toast.update(group.id, { content })
            return
        }

        const id = toast(content, {
            position: 'top-right',
            timeout: false,
            closeOnClick: false,
            toastClassName: 'app-common-notification',
            onClose: () => {
                if (key !== null) groups.delete(key)
            },
        })
        if (key !== null) groups.set(key, { id, fields })
    }

    const dispose = () => {
        groups.forEach(group => toast.dismiss(group.id))
        groups.clear()
    }

    onScopeDispose(dispose)

    return { show, dispose }
}